import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import { withStyles } from '@material-ui/core/styles';
import Typography from '../components/Typography';
import productBuoy from '../../photos/productBuoy2.svg';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(7),
    marginBottom: theme.spacing(4),
  },
  button: {
    border: '4px solid currentColor',
    borderRadius: 0,
    height: 'auto',
    padding: theme.spacing(2, 5),
  },
  link: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    color: 'green', // Зелений колір
  },
  buoy: {
    width: 30,
  },
});

function ProductSmokingHero(props) {
  const { classes } = props;

  return (
    <Container className={classes.root} component="section">
      <Button href="viber://chat?number=%2B380960968402" className={classes.button}>
        <Typography variant="h4" component="span">
          <span className={classes.link}>Зв'язок з бухгалтером у месенджері</span> &nbsp;
          <img src={productBuoy} className={classes.buoy} alt="buoy" />
        </Typography>
      </Button>
    </Container>
  );
}

ProductSmokingHero.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProductSmokingHero);
